import $ from 'jquery'
import _throttle from 'lodash/throttle'

const $body = $('body')
const $document = $(document)
let $hideAroundSections = []

export function init() {
  $('[data-menu-toggle]').on('click', function (event) {
    toggleMenu($(this))
    event.stopPropagation()
  })

  $hideAroundSections = $('section.whats-golden-hero, section.map-section')

  $document.on('scroll', _throttle(handleScroll, 1000 / 10))
  handleScroll()
}

export function toggleMenu($elem) {
  $body.toggleClass('menu-open')
  if (!$body.hasClass('menu-open') && $('[data-menu-toggle].clicked').length)
    $('[data-menu-toggle].clicked').removeClass('clicked')
  if ($elem && $elem.find('#hamburger').length) $elem.addClass('clicked')
}

function handleScroll() {
  const scrollPos = $document.scrollTop()
  if (scrollPos > 100) {
    if (!$body.hasClass('hide-logo')) $body.addClass('hide-logo')
  } else {
    if ($body.hasClass('hide-logo')) $body.removeClass('hide-logo')
  }

  if ($hideAroundSections.length > 0) {
    const logoRect = $('.header .logo-title img, .header .logo-title svg')[0].getBoundingClientRect()
    let hide = false
    $hideAroundSections.each((i, elem) => {
      const sectionRect = $(elem)[0].getBoundingClientRect()
      const heightBuffer = sectionRect.height * 0.25
      if (logoRect.top < sectionRect.bottom - heightBuffer && logoRect.bottom > sectionRect.top + heightBuffer)
        hide = true
    })
    if (hide && !$body.hasClass('completely-hide-logo')) $body.addClass('completely-hide-logo')
    if (!hide && $body.hasClass('completely-hide-logo')) $body.removeClass('completely-hide-logo')
  }
}
